import { Mutation } from 'app/types/mutation'
import { gql } from 'graphql-request'

export const toggleLike = () => gql`
  mutation toggleLike($id: String!) {
    toggleLike(id: $id) {
      id
      success
      reason
    }
  }
`

export const likeResult = (data: any) => {
  return data.toggleLike as Mutation
}
